// extracted by mini-css-extract-plugin
export default {"slides":"styles_slides__vAoH3"};